import { STATUS_CODE } from '~/constants'
import { ENDPOINT } from './endPoint'
import request from './request'

export const getListServingTablesApi = async ({ restaurantSlug }) => {
  const params = {}

  if (restaurantSlug) params.restaurant_slug = restaurantSlug

  try {
    const { data, status } = await request().get(ENDPOINT.SERVING_TABLES_LIST, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.data || [],
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: [],
    }
  }
}
